__webpack_require__.p = "https://dev.mind.creai.cloud/";